import { Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useAddModuleAttachmentMutation, useDeleteModuleAttachmentMutation } from "../../../../api/rtk/SignUpApi";
import { DocumentReferenceViewModel } from "../../../../model/DocumentReferenceViewModel";
import DocumentList from "../../../common/DocumentList";
import UploadDropZone from "../../../common/UploadDropZone";
import TranslatedMessage from "../../../translations/TranslatedMessage";
import { ApiResponse } from "../../../../api/CustomFetch";
import useNotification from "../../../../utils/useNotification";
import { GetTranslation } from "../../../../translations/GetTranslation";
import { useIntl } from "react-intl";

type ModuleAttachmentsProps = {
  moduleId: string;
  attachments: DocumentReferenceViewModel[];
  willProvideDocumentsLater?: boolean;
  setWillProvideDocumentsLater: (value: boolean | undefined) => void;
};

const ModuleAttachments: React.FunctionComponent<ModuleAttachmentsProps> = ({
  moduleId,
  attachments,
  willProvideDocumentsLater,
  setWillProvideDocumentsLater,
}) => {
  const [addModuleAttachment] = useAddModuleAttachmentMutation();
  const [deleteModuleAttachment] = useDeleteModuleAttachmentMutation();
  const {error} = useNotification();
  const intl = useIntl();

  const handleUploadError = (response?: ApiResponse<any>) => {
    const errorMessage = (response?.errors?.length ?? 0) > 0 ? response!.errors![0] : GetTranslation(intl, "common.uploadError");
    error(errorMessage);
  }

  return (
    <Grid item container spacing={2} style={{ marginTop: "12px" }}>
      <Grid item xs={12}>
        <Typography>
          <TranslatedMessage id="startCertification.modulesDetailsStep.docsText1" />
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>
          <TranslatedMessage id="startCertification.modulesDetailsStep.docsText2" />
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={willProvideDocumentsLater ?? false}
              onChange={(event) => setWillProvideDocumentsLater(event.target.checked)}
            />
          }
          label={<TranslatedMessage id="startCertification.modulesDetailsStep.willUploadDocsLater" />}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <UploadDropZone accept=".jpg,.jpeg,.png,.pdf" postFileFn={(file) => addModuleAttachment({ moduleId, file })} onUploadError={handleUploadError}/>
      </Grid>
      <Grid item xs={12} sm={8}>
        <DocumentList
          documents={attachments}
          onDeleteFile={(file: DocumentReferenceViewModel) =>
            deleteModuleAttachment({
              moduleId,
              fileName: file.name,
            })
          }
        />
      </Grid>
    </Grid>
  );
};

export default ModuleAttachments;
